import React from 'react';
export function Footer() {
  return <footer className="w-full bg-cream px-5 py-10" data-id="element-58" data-mp="32wd0e9mw79qd">
      <div className="mx-auto max-w-2xl text-center" data-id="element-59" data-mp="3gezev8fo7z39">
        <p className="font-serif-display text-base font-semibold text-plum" data-id="element-60" data-mp="3ggk6oqalp3xf">Aura Viva 2026</p>
        <p className="mt-1 text-xs font-medium text-aura" data-id="element-61" data-mp="32pfc42m3b1ty">
          Producto digital de autocuidado y bienestar.
        </p>

        <div className="mx-auto mt-5 h-px w-16 bg-gold/50" data-id="element-62" data-mp="36n3axgqwler4" />

        <div className="mt-5 space-y-3 text-xs leading-relaxed text-plum/70" data-id="element-63" data-mp="3ugboz385h6h8">
          <p data-id="element-64" data-mp="38z70lzg0p09">
            El contenido de Aura Viva 2026 tiene fines educativos y de bienestar general. No
            constituye asesoramiento médico o psicológico, no realiza diagnósticos y no reemplaza
            tratamientos ni atención profesional.
          </p>
          <p data-id="element-65" data-mp="29z6x2jmuoxjl">Producto 100 % digital. No se realizan envíos físicos.</p>
          <p data-id="element-66" data-mp="2a19u3nmf7qxt">
            El contenido adquirido es para uso personal. No está permitida su reventa, distribución
            ni reproducción comercial.
          </p>
        </div>

        <p className="mt-6 text-xs text-plum/60" data-id="element-67" data-mp="3la29euiur3v8">
          © {new Date().getFullYear()} Aura Viva 2026. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}